
        var result = require("!!../../../node_modules/css-loader/index.js!./training.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/training/training.component.css
// module id = 420
// module chunks = 2